export default __webpack_public_path__ + "f7683b53017547196d7242fb89e1321c.png";